const MsftLogo = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path fill="#f25022" d="M22 22H11V11h11z" />
      <path fill="#00a4ef" d="M22 37H11V26h11z" />
      <path fill="#7fba00" d="M37 22H26V11h11z" />
      <path fill="#ffb900" d="M37 37H26V26h11z" />
    </g>
  </svg>
);

// This component renders the Microsoft logo using SVG.
export default MsftLogo;
